import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, Event as RouterEvent, RouterOutlet } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { Observable, Subscription } from 'rxjs';

import { CommonToastComponent } from '@common/infraestructure/components/toast/toast.component';
import { CommonLoadingComponent } from '@common/infraestructure/components/loading/loading.component';
import { LoadingAbstraction } from './common/ports/abstractions/loading/loading.abstraction';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    CommonToastComponent,
    CommonLoadingComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  private primeNGConfig = inject(PrimeNGConfig);
  private http = inject(HttpClient);
  private _getJsonData: Subscription = new Subscription();
  private loadingAbstraction = inject(LoadingAbstraction)

  constructor(private router: Router) {
    this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        if (!event.url.includes('/auth/loginadministrative') || !event.url.includes('/salesclient')) {
          this.loadingAbstraction.show();
        }
      }

      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.loadingAbstraction.hide();
      }
    });
  }


  ngOnInit(): void {
    this._getJsonData = this.getJsonData().subscribe(data => {
      this.primeNGConfig.setTranslation(data);
    });
  }

  getJsonData(): Observable<any> {
    return this.http.get<any>('assets/locale/es.json');
  }

  ngOnDestroy(): void {
    this._getJsonData.unsubscribe();
  }
}
